import { useCallback, useContext } from 'react';
import SegmentationFiltersInstanceContext from 'customer-data-filters-ui/state/SegmentationFiltersInstanceContext';
import { useStrategy } from './useStrategy';
import { isAnyEventTypeId } from 'customer-data-filters-ui/filterQueryFormat/ObjectTypeId';
import { useEditorActions } from './useEditorActions';
import { setKeyPath } from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
export const useUnifiedEventCompletionStatus = (logicGroup, logicGroupPath) => {
  const {
    internalDraftValue
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    isNotCompletedUnifiedEventFiltersEnabled
  } = useStrategy();
  const {
    onChangeInternal
  } = useEditorActions();
  const showUnifiedEventCompletionStatus = isAnyEventTypeId(logicGroup.filterFamily);
  const onUnifiedEventCompletionStatusChange = useCallback(hasCompletedUnifiedEvent => {
    const newLogicGroup = logicGroup.set('hasNotCompletedUnifiedEvent', !hasCompletedUnifiedEvent);
    const newInternalDraftValue = setKeyPath(logicGroupPath, hasCompletedUnifiedEvent ? newLogicGroup : newLogicGroup.remove('refinements'), internalDraftValue);
    onChangeInternal(newInternalDraftValue);
  }, [logicGroup, internalDraftValue, logicGroupPath, onChangeInternal]);
  const showUnifiedEventCompletionStatusSelect = showUnifiedEventCompletionStatus && isNotCompletedUnifiedEventFiltersEnabled;
  return {
    showUnifiedEventCompletionStatus,
    showUnifiedEventCompletionStatusSelect,
    onUnifiedEventCompletionStatusChange
  };
};